import { DataSender } from '../loaders'
import { Validation, FormValidation } from '../validation/validation';
import { loadStripe } from '@stripe/stripe-js';

/**
* BuyTicketsModal
*/

const BuyTicketsModalEmbedLayout = {
    INLINE: 'inline',
    BUTTON_SMALL: 'button-small',
    BUTTON_NORMAL: 'button-normal',
    BUTTON_BIG: 'button-big',
    array: function() {
        var a = []; for(var i in this) if(typeof this[i] == 'string') a.push(this[i]);
        return a;
    }
};

const BuyTicketsModalEmbedLayoutProperties = {
    'inline': {
        frameHeight: '550px',
        frameWidth: '750px'
    },

    'button-small': {
        frameHeight: '30px',
        frameWidth: '120px'
    },

    'button-normal': {
        frameHeight: '50px',
        frameWidth: '180px'
    },

    'button-big': {
        frameHeight: '70px',
        frameWidth: '240px'
    }
};

const BuyTicketsModalPaymentMethod = {
    PAYPAL: 'paypal',
    STRIPE: 'stripe'
};

class BuyTicketsModal {
    constructor(target, eventId, callback, options) {
        if(!target || !target.length || !eventId) {
            window.activeModalInstance = null;
            return;
        }

        if(!options) options = {};

        this.validation = eved.Validation;

        // properties
        this.target = target;
        this.callback = (callback) ? callback : null;
        this.data = {
            event_id: eventId,
            name: null,
            email: null,
            discount: null,
            tickets: [],
            currency: 'usd',
            value: 0,
            num_items: 0
        };
        
        this.embed = (options.embed) ? true : false;

        if(this.embed) {
            this.embedLayout = ($.inArray(options.embed, BuyTicketsModalEmbedLayout.array()) >= 0) ? options.embed : BuyTicketsModalEmbedLayout.BUTTON_NORMAL;
            this.finishOrderId = 0;
            this.loadFinishStepOnOpen = false;
        }
        else {
            this.finishOrderId = (options.finishOrderId) ? options.finishOrderId : 0;
            this.loadFinishStepOnOpen = (this.finishOrderId) ? true : false;
        }

        this.trackingCallback = (options.trackingCallback) ? options.trackingCallback : false;

        this.currentStep = 0;
        this.locked = false;
        this.ticketsOrderId = null;

        // init
        this.loadModal();
        $(document).keypress(function(e) {
            if (e.keyCode === 27) {
                this.closeModal();
            }
        });

    }

    lock() {
        this.locked = true;
    }

    unlock() {
        this.locked = false;
    }

    slide(target, step) {
        target.css('-webkit-transform', 'translateX(' + (step * -800) + 'px)');
        target.css('-moz-transform', 'translateX(' + (step * -800) + 'px)');
        target.css('transform', 'translateX(' + (step * -800) + 'px)');
    }

    slideToStep(step) {
        this.slide(this.steps, step);
    }

    slideToSubstep(target, step) {
        this.slide(target, step);
    }

    showLogotype(topPosition) {
        if(this.headerLogotype) {
            this.headerLogotype.addClass('shown');

            if(topPosition) {
                this.headerLogotype.css('top', Math.max(topPosition, -80));
            }
        }
        else {
            this.showLogotypeOnOpen = true;
            this.logotypeTopPosition = topPosition;
        }
    }

    hideLogotype() {
        if(this.headerLogotype) {
            this.headerLogotype.removeClass('shown');
        }
    }

    lockFormsExcept(what) {
        if (this.selectStep && this.selectStep.length) {
            if (what == 'select') {
                this.selectStep.find('input, select').prop('disabled', false);
            }
            else {
                this.selectStep.find('input, select').prop('disabled', true);
            }
        }

        if (this.requiredInformationStep && this.requiredInformationStep.length) {
            if (what == 'required_information') {
                this.requiredInformationStep.find('input, select').prop('disabled', false);
            }
            else {
                this.requiredInformationStep.find('input, select').prop('disabled', true);
            }
        }

        if (this.paymentStep && this.paymentStep.length) {
            if (what == 'payment') {
                this.paymentStep.find('input, select').prop('disabled', false);
            }
            else {
                this.paymentStep.find('input, select').prop('disabled', true);
            }
        }
    }

    back() {
        if(this.locked) return;
        this.lock();

        this.currentStep--;
        if(this.currentStep < 0) this.currentStep = 0;

        switch(this.currentStep) {
            case 0: this.closeCompleteStep(); break;
        }
    }

    next() {
        if(this.locked) return;
        this.lock();

        this.currentStep++;
        if(this.currentStep > 2) this.currentStep = 2;

        switch(this.currentStep) {
            case 1: this.loadCompleteStep(); break;
            case 2: this.loadFinishStep(); break;
        }
    }

    serializeData() {
        var that = this;

        this.data.name = $.trim(this.selectName.val());
        this.data.email = $.trim(this.selectEmail.val().toLowerCase());
        this.data.discount = $.trim(this.selectDiscount.val());
        this.data.tickets = [];

        var selectedTicketsCount = 0;
        var selectedTicketsPrice = 0;

        if(this.ticketCategoriesList) {
            this.ticketCategoriesList.filter(':not(.disabled)').each(function() {
                var category = $(this);
                var quantitySelect = category.find('select[name="quantity"]');

                if(parseInt(quantitySelect.val())) {
                    that.data.tickets.push({
                        id: category.data('category-id'),
                        quantity: quantitySelect.val()
                    });

                    selectedTicketsCount += parseInt(quantitySelect.val());
                    selectedTicketsPrice += parseInt(quantitySelect.val()) * category.data('price');
                }
            });
        }

        if(this.data.tickets.length) {
            var summary = (selectedTicketsCount == 1) ? this.texts.summaryFormatSingular : this.texts.summaryFormatPlural;
            summary = summary.replace(/%d/, selectedTicketsCount);
            summary = summary.replace(/%s/, this.texts.priceFormat.replace(/%s/, selectedTicketsPrice.toFixed(2)));

            this.selectSubmit.addClass('active details');
            this.selectSubmit.find('span').text(summary);
        }
        else {
            this.selectSubmit.removeClass('active details');
        }
    }

    checkData() {
        this.serializeData();

        if(!this.data.tickets.length) {
            if(this.ticketCategoriesList.filter(':not(.disabled)').length) {
                this.selectSubmit.highlight('red', { hideEvent: 'mouseleave', offset: [0,-7], text: this.texts.noSelectedTicketsError });
            }
            return false;
        }

        if(!this.data.name) {
            this.selectName.highlight('red', { hideEvent: 'input', offset: [0, -25], text: this.texts.noNameError }).focus();
            return false;
        }

        if(!this.validation.isValidFirstLastName(this.data.name)) {
            this.selectName.highlight('red', { hideEvent: 'input', offset: [0,-25], text: this.texts.noValidNameError }).select();
            return false;
        }

        if(!this.data.email) {
            this.selectEmail.highlight('red', { hideEvent: 'input', offset: [0,-25], text: this.texts.noEmailError }).focus();
            return false;
        }

        if(!this.validation.isValidEmail(this.data.email)) {
            this.selectEmail.highlight('red', { hideEvent: 'input', offset: [0,-25], text: this.texts.noValidEmailError }).select();
            return false;
        }

        return true;
    }

    deleteOrder() {
        if(this.ticketsOrderId) {
            new DataSender({
                data: {
                    email: this.data.email,
                    id: this.ticketsOrderId,
                    origin: (this.embed) ? 'embed' : 'web'
                },
                url: '/event/tickets/delete-order/'
            });

            this.ticketsOrderId = null;
        }
    }

    // MODAL

    loadModal() {
        var that = this;

        this.target.html('<div class="activity-indicator gray"></div>');
        (!this.loadFinishStepOnOpen) ? this.target.addClass('fade show') : this.target.removeClass('fade show');
        this.target.show();

        if(this.trackingCallback) {
            this.trackingCallback({ event: 'opened' });
        }

        new DataSender({
            data: {
                embed: (this.embed) ? this.embedLayout : 0,
                id: this.data.event_id,
                finish: (this.loadFinishStepOnOpen) ? 1 : 0,
                order_id: this.finishOrderId,
                origin: (this.embed) ? 'embed' : 'web'
            },
            url: '/event/tickets/load/',

            success: function(data) {
                if(data.status) {
                    that.target.html(data.html);

                    that.eventTitle = data.event_title;
                    that.texts = window.buyTicketsModalTexts;

                    that.initModal();

                    if(!that.loadFinishStepOnOpen) {
                        that.initSelectStep();
                    }
                    else {
                        that.initFinishStep();
                    }
                }
            },

            error: function() {
                that.closeModal();
            }
        });
    }

    initModal() {
        var that = this;

        this.header = this.target.find('.modal-header');
        this.headerLogotype = this.header.find('a.logotype');

        if(this.showLogotypeOnOpen) {
            this.showLogotype(this.logotypeTopPosition);
            this.showLogotypeOnOpen = null;
            this.logotypeTopPosition = null;
        }

        this.headerBackButton = this.header.find('button.back');
        this.headerBackButton.bind('click', function() {
            if(that.locked) return;

            if(that.headerBackButton.hasClass('shown')) {
                if(!that.backToRequiredInformationStep) {
                    if(window.confirm(that.texts.cancelOrderConfirm)) {
                        that.back();
                    }
                }
                else {
                    that.backToRequiredInformationStep = false;
                    that.slideToSubstep(that.completeStepWrapper, 0);
                    that.lockFormsExcept('required_information');
                }
            }
        });

        this.headerCloseButton = this.header.find('button.close');
        this.headerCloseButton.bind('click', function() {
            if(that.locked) return;

            if(that.data.tickets.length) {
                if(window.confirm(that.texts.progressConfirm)) {
                    that.closeModal();
                }
            }
            else {
                that.closeModal();
            }
        });

        if(this.embed && this.embedLayout == BuyTicketsModalEmbedLayout.INLINE) {
            this.headerCloseButton.remove();
        }

        this.steps = this.target.find('.modal-body').find('.wrapper');
        this.selectStep = this.steps.find('.select');
        this.completeStep = this.steps.find('.complete');
        this.finishStep = this.steps.find('.finish');

        this.footerMessage = this.target.find('.modal-footer').find('p');

        if(this.trackingCallback) {
            this.trackingCallback({ event: 'ready' });
        }
    }

    closeModal() {
        if(this.embed && this.embedLayout == BuyTicketsModalEmbedLayout.INLINE) {
            return;
        }

        this.deleteOrder();
        this.stopCountdown();

        if(this.callback) {
            if(this.success) {
                this.callback({ success: true });
            }
            else {
                this.callback({ success: false });
            }
        }

        if(this.trackingCallback) {
            this.trackingCallback({ event: 'closed' });
        }

        this.target.hide();
        $('body').removeClass('modal-open');
        $('.modal-bs-backdrop').remove();


        window.activeModalInstance = null;
    }

    // 1. SELECT

    initSelectStep() {
        var that = this;

        this.ticketCategoriesList = this.selectStep.find('table.list').find('tr');
        this.ticketCategoriesList.find('select[name="quantity"]').bind('change', function() {
            that.serializeData();
        });

        this.selectForm = this.selectStep.find('form');
        this.selectForm.bind('submit', function() {
            that.next();
            return false;
        });

        this.selectName = this.selectForm.find('input[name="name"]');
        this.selectEmail = this.selectForm.find('input[name="email"]');
        this.selectDiscount = this.selectForm.find('input[name="discount"]');

        this.selectSubmit = this.selectForm.find('a.btn-primary');
        this.selectSubmit.bind('click', function() {
            that.selectForm.submit();
            return false;
        });

        this.lockFormsExcept('select');

        window.setTimeout(function() {
            that.footerMessage.removeClass('hidden');
        }, 750);
    }

    refreshSelectStep() {
        var that = this;
        this.lock();

        this.selectStep.find('table.head').remove();
        this.selectStep.find('div.mask').remove();
        this.selectStep.prepend('<div class="mask"><div class="activity-indicator gray"></div></div>');

        this.ticketCategoriesList = null;
        this.serializeData();

        new DataSender({
            data: {
                id: this.data.event_id,
                origin: (this.embed) ? 'embed' : 'web'
            },
            url: '/event/tickets/refresh-categories/',

            success: function(data) {
                if(data.status) {
                    that.selectStep.find('div.mask').remove();
                    that.selectStep.prepend(data.html);

                    that.ticketCategoriesList = that.selectStep.find('table.list').find('tr');
                    that.ticketCategoriesList.find('select[name="quantity"]').bind('change', function() {
                        that.serializeData();
                    });
                }

                that.unlock();
            }
        });
    }

    // 2. COMPLETE:

    loadCompleteStep() {
        var that = this;

        if(!this.checkData()) {
            this.currentStep--;
            this.unlock();
            return;
        }
        else {
            if(this.trackingCallback) {
                this.trackingCallback({ event: 'order_now_clicked' });
            }
        }

        this.slideToStep(1);
        this.completeStep.html('<div class="activity-indicator gray"></div>');

        new DataSender({
            data: $.extend(this.data, {
                origin: (this.embed) ? 'embed' : 'web'
            }),
            url: '/event/tickets/complete/',

            success: function(data) {
                if(data && data.status) {
                    that.ticketsOrderId = data.order;

                    // GO TO FINISH:
                    if(data.finish_order) {
                        that.completeStep.remove();
                        that.skipCompleteStep = true;
                        that.loadFinishStep();
                    }

                    // GO TO COMPLETE:
                    else {
                        window.loadStripe = loadStripe;
                        that.completeStep.html(data.html);
                        that.completeStepSteps = {
                            information: data.complete_information_form,
                            payment: data.payment_form
                        };
                        that.initCompleteStep();
                    }
                }
                else {
                    window.setTimeout(function() {
                        that.unlock();
                        that.back();
                    }, 400);
                }
            },

            error: function(e) {
                window.setTimeout(function() {
                    that.unlock();
                    that.back();
                }, 400);
            }
        });
    }

    initCompleteStep() {
        var that = this;

        this.headerBackButton.addClass('shown');

        this.completeCountdown = this.completeStep.find('span.countdown');
        this.startCountdown();

        this.completeStepWrapper = this.completeStep.find('.wrapper');
        this.requiredInformationStep = this.completeStepWrapper.find('.required-information');
        this.paymentStep = this.completeStepWrapper.find('.payment');

        if(this.completeStepSteps.information) {
            this.initRequiredInformationForm();
        }

        if(this.completeStepSteps.payment) {
            this.initPaymentForm();
        }

        if(this.completeStepSteps.information) {
            this.lockFormsExcept('required_information');
        }
        else if(!this.completeStepSteps.information && this.completeStepSteps.payment) {
            this.lockFormsExcept('payment');
        }

        this.unlock();
    }

    initRequiredInformationForm() {
        var that = this;

        // FORM AND FIELDS:
        this.requiredInformationForm = this.requiredInformationStep.find('.mask').find('form');
        this.requiredInformationForm.find('fieldset').find('div.divider:last-child').remove();

        var fv = new FormValidation(this.requiredInformationForm);

        this.requiredInformationFormFields = this.requiredInformationForm.find('input, select');
        this.requiredInformationFormFields.each(function() {
            var field = $(this);
            var fieldType = field.data('field-type');

            if(field.prop('tagName') == 'SELECT') {
                field.addClass('not-selected');
                field.bind('change', function() {
                    if(!field.val().length) {
                        field.addClass('not-selected');
                    }
                    else {
                        field.removeClass('not-selected');
                    }
                });
            }
            switch(fieldType) {
                case 'full_name':
                    fv.addRule(field, 'REQUIRED', null, that.texts.noRequiredNameError);
                    break;

                case 'email':
                    field.bind('blur', function(){ field.val(field.val().toLowerCase()); })
                    fv.addRule(field, 'REQUIRED', null, that.texts.noRequiredEmailError);
                    fv.addRule(field, 'VALID_EMAIL', null, that.texts.noValidEmailError);
                    break;

                case 'tshirt':
                    fv.addRule(field, 'REQUIRED', null, that.texts.noRequiredTshirtError);
                    break;

                case 'age':
                    fv.addRule(field, 'REQUIRED', null, that.texts.noRequiredAgeError);
                    break;

                case 'gender':
                    fv.addRule(field, 'REQUIRED', null, that.texts.noRequiredGenderError);
                    break;

                case 'phone':
                    fv.addRule(field, 'REQUIRED', null, that.texts.noRequiredPhoneError);
                    break;

                default:
                    fv.addRule(field, 'REQUIRED', null, that.texts.noRequiredCustomQuestionError);
                    break;
            }

            field.data('scroll-offset', field.parent().position().top + field.parent().parent().position().top - 30);
        });

        fv.errorsHandler = function(errors) {
            that.requiredInformationFormFields.removeHighlight();

            for(var i in errors) {
                var tag = errors[i].target.prop('tagName');
                var hideEvent = (tag == 'INPUT') ? 'input' : 'click';
                var offset = (errors[i].target.prev('a.autofill').length) ? [31, 0] : [0, 0];

                errors[i].target.highlight('red', { hideEvent: hideEvent, offset: offset, placement: 'right', text: errors[i].error });
                errors[i].target.select();

                that.requiredInformationForm.parent().animate( { scrollTop: errors[i].target.data('scroll-offset') }, { duration: 200, queue: false } );

                break;
            }
        };

        fv.successHandler = function() {
            if(that.trackingCallback) {
                that.trackingCallback({ event: 'save_information_clicked' });
            }

            that.saveRequiredInformationData();
        };

        // AUTOFILL:
        this.requiredInformationFormAutofillButtons = this.requiredInformationForm.find('a.autofill');
        this.requiredInformationFormAutofillButtons
            .bind('click', function() {
                var button = $(this);
                var field = button.next('*');

                button.addClass('highlighted').tooltip('hide');
                field.addClass('highlighted').removeClass('not-selected').val(button.data('autofill'));

                window.setTimeout(function() {
                    button.removeClass('highlighted');
                    field.removeClass('highlighted');
                }, 400);

                return false;
            })
            .bind('mouseover', function() {
                $(this).next('*').removeHighlight();
            })
            .tooltip({ animation: false });

        // SUBMIT:
        this.requiredInformationFormSubmit = this.requiredInformationStep.find('form.bottom').find('a.btn-primary');
        this.requiredInformationFormSubmit.bind('click', function() {
            that.requiredInformationForm.submit();
            return false;
        });
    }

    saveRequiredInformationData() {
        var that = this;
        this.saveRequiredInformation = [];

        this.requiredInformationForm.find('div.category').each(function() {
            var category = $(this);
            var categoryData = { category_id: category.data('id'), information: [] };
            var fieldsetData = [];

            category.find('fieldset').each(function() {
                var fieldsetData = [];

                $(this).find('input, select').each(function() {
                    var value = $(this).val();

                    if($(this).prop('tagName') == 'SELECT') {
                        if($(this).find('option:selected').data('value')) {
                            value = $(this).find('option:selected').data('value');
                        }
                    }

                    fieldsetData.push({
                        type: $(this).data('type'),
                        field_type: $(this).data('field-type'),
                        field_label: $(this).data('type') == 'custom' ? $(this).prop('placeholder') : null,
                        value: value
                    });
                });

                categoryData.information.push(fieldsetData);
            });

            that.saveRequiredInformation.push(categoryData);
        });

        if(!this.completeStepSteps.payment) {
            this.stopCountdown();
            this.next();
        }
        else {
            this.backToRequiredInformationStep = true;
            this.slideToSubstep(this.completeStepWrapper, 1);

            this.lockFormsExcept('payment');
        }
    }

    initPaymentForm() {
        var that = this;

        this.paymentStepOverview = this.paymentStep.find('div.mask');

        window.setTimeout(function() {
            that.paymentStepOverview.animate({ scrollTop: that.paymentStepOverview[0].scrollHeight }, 600);
        }, 1000);

        this.paymentStepMethods = this.paymentStep.find('div.payment-methods');
        this.paymentStepMethods.css({ paddingTop: Math.round((this.paymentStepMethods.parent().outerHeight() - this.paymentStepMethods.position().top - this.paymentStepMethods.outerHeight()) * 0.2) });

        // OTHER:
        this.otherForm = this.paymentStepMethods.find('form.other');

        if(this.otherForm.length) {
            this.otherForm.bind('submit', function() {
                return false;
            });

            this.paypalButton = this.otherForm.find('a.paypal-button');
            this.stripeForm = $('form.stripe');

            // PAYPAL:
            if(this.paypalButton.length) {
                this.paypalButton.bind('click', function() {
                    if(!that.locked) {
                        that.paypalButtonForm.prop('target', '_blank').submit();

                        that.usedPaymentMethod = BuyTicketsModalPaymentMethod.PAYPAL;
                        that.stopCountdown();
                        that.next();
                    }

                    return false;
                });

                this.paypalButtonForm = this.paymentStepMethods.find('form.paypal-button-form');
            }

            // STRIPE:
            if(this.stripeForm.length) {

                var clientSecret = document.getElementById('clientSecret').value;
                this.data.value = document.getElementById('priceVal').value;
                this.data.currency = document.getElementById('currency').value;

                var form = document.getElementById('payment-form');

                // Set your publishable key: remember to change this to your live publishable key in production
                // See your keys here: https://dashboard.stripe.com/account/apikeys
                var stripe = Stripe(window.stripePublicKey);

                var elements = stripe.elements();


                // Custom styling can be passed to options when creating an Element.
                var style = {
                  base: {
                    // Add your base input styles here. For example:
                    fontSize: '16px',
                    color: '#32325d',
                  },
                };

                var card = elements.create("card", { style: style });
                card.mount("#card-element");

                form.addEventListener('submit', function(ev) {
                  ev.preventDefault();
                  stripe.confirmCardPayment(clientSecret, {
                    payment_method: {
                      card: card
                    }
                  }).then(function(result) {
                    if (result.error) {
                      // Show error to your customer (e.g., insufficient funds)
                      var displayError = document.getElementById('card-errors');
                      if (result.error) {
                        displayError.textContent = result.error.message;
                      } else {
                        displayError.textContent = '';
                      }
                    } else {
                      // The payment has been processed!
                      if (result.paymentIntent.status === 'succeeded') {
                        // Show a success message to your customer
                        // There's a risk of the customer closing the window before callback
                        // execution. Set up a webhook or plugin to listen for the
                        // payment_intent.succeeded event that handles any business critical
                        // post-payment actions.

                        that.next();
                      }
                    }
                  });
                });

                card.on('change', function(event) {
                  var displayError = document.getElementById('card-errors');
                  if (event.error) {
                    displayError.textContent = event.error.message;
                  } else {
                    displayError.textContent = '';
                  }
                });

                // Create a token or display an error when the form is submitted.
                var form = document.getElementById('payment-form');
                form.addEventListener('submit', function(event) {
                  event.preventDefault();

                  stripe.createToken(card).then(function(result) {
                    if (result.error) {
                      // Inform the customer that there was an error.
                      var errorElement = document.getElementById('card-errors');
                      errorElement.textContent = result.error.message;
                    } else {
                      // Send the token to your server.
                      stripeTokenHandler(result.token);
                    }
                  });
                });

                function stripeTokenHandler(token) {
                  // Insert the token ID into the form so it gets submitted to the server
                  var form = document.getElementById('payment-form');
                  var hiddenInput = document.createElement('input');
                  hiddenInput.setAttribute('type', 'hidden');
                  hiddenInput.setAttribute('id','stripeToken');
                  hiddenInput.setAttribute('name', 'stripeToken');
                  hiddenInput.setAttribute('value', token.id);
                  form.appendChild(hiddenInput);

                  // Submit the form
                  that.usedPaymentMethod = BuyTicketsModalPaymentMethod.STRIPE;
                }
            }
        }
    }

    setSendingRequest(value) {
        this.sendingRequest = value;

        if(value === false && this.secondsLeft < 1) {
            window.alert(this.texts.orderTimeIsUpError);
            this.back();
        }
    }

    startCountdown() {
        var that = this;

        this.secondsLeft = this.completeCountdown.data('seconds');
        this.setSendingRequest(false);

        this.completeCountdownInterval = window.setInterval(function() {
            that.secondsLeft--;

            let minutes = Math.floor(that.secondsLeft / 60);
            if(minutes < 10) minutes = '0' + minutes;

            let seconds = that.secondsLeft % 60;
            if(seconds < 10) seconds = '0' + seconds;

            that.completeCountdown.text(minutes + ':' + seconds);

            if(that.secondsLeft < 60) {
                that.completeCountdown.addClass('attention');

                if(that.secondsLeft < 1) {
                    that.stopCountdown();

                    if(!that.sendingRequest) {
                        window.alert(that.texts.orderTimeIsUpError);
                        that.back();
                    }
                }
            }
        }, 1000);
    }

    stopCountdown() {
        window.clearInterval(this.completeCountdownInterval);
    }

    closeCompleteStep() {
        var that = this;

        this.deleteOrder();
        this.slideToStep(0);
        this.stopCountdown();

        this.headerBackButton.removeClass('shown');
        this.lockFormsExcept('select');

        window.setTimeout(function() {
            that.completeStep.html('');
            that.unlock();
            that.refreshSelectStep();
        }, 500);
    }

    // 3. FINISH:

    loadFinishStep() {
        var that = this;

        if(this.skipCompleteStep) {
            this.redirectFinishStep = false;
            this.finishStep.html('<div class="activity-indicator gray"></div>');
        }
        else {
            this.slideToStep(2);
            this.finishStep.html('<div class="activity-indicator gray"></div>');

            if(this.usedPaymentMethod == BuyTicketsModalPaymentMethod.STRIPE || this.usedPaymentMethod == BuyTicketsModalPaymentMethod.PAYPAL) {
                this.redirectFinishStep = true;
            }
            else {
                this.redirectFinishStep = false;
            }
        }

        var stripeToken = document.getElementById('stripeToken');
        if (stripeToken) stripeToken = stripeToken.value;
        var currency = document.getElementById('currency');
        if (currency) currency = currency.value;

        new DataSender({
            data: {
                id: this.ticketsOrderId,
                method: this.usedPaymentMethod,
                origin: (this.embed) ? 'embed' : 'web',
                redirect: (this.redirectFinishStep) ? 1 : 0,
                required_information: (this.saveRequiredInformation) ? this.saveRequiredInformation : null,
                stripeToken: stripeToken,
                currency: currency
            },
            url: '/event/tickets/finish/',

            success: function(data) {
                if(data && data.status) {
                    // that.data.name = null;
                    // that.data.email = null;
                    // that.data.tickets = [];
                    // that.ticketsOrderId = null

                    that.finishStep.html(data.html);
                    that.initFinishStep();
                } else {
                    console.log(data);
                    that.unlock();
                    that.back();
                }
            },

            error: function(e) {
                that.unlock();
                that.back();
            }
        });
    }

    buildPurchaseContents() {
        var contents = [];

        if (!this.ticketCategoriesList || !this.data.tickets) {
            return contents;
        }

        this.data.tickets.forEach((ticket) => {
            var category = this.ticketCategoriesList.filter('[data-category-id="' + ticket.id + '"]');
            contents.push({
                id: String(ticket.id),
                quantity: parseInt(ticket.quantity, 10),
                item_price: parseFloat(category.data('price') || 0),
                content_name: category.data('name') || ''
            });
        });

        return contents;
    }

    buildPurchaseMetaParams() {
        var params = {
            value: this.data.value,
            currency: this.data.currency,
            num_items: this.data.num_items,
            contents: this.buildPurchaseContents()
        };

        if (this.eventTitle) {
            params.content_name = this.eventTitle;
        }

        return params;
    }

    initFinishStep() {
        var that = this;
        
        this.data.tickets.forEach(t => this.data.num_items += t.quantity)
        
        !function (f, b, e, v, n, t, s) {
            if (f.fbq)
                return;
            n = f.fbq = function () {
                n.callMethod ?
                    n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            };
            if (!f._fbq)
                f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s)
        }(window,
            document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        
        fbq('init', window.fbPixelId);
        var purchaseParams = this.buildPurchaseMetaParams();
        window.trackMetaPixel('Purchase', purchaseParams);
        if (typeof window.trackPromoterPixel === 'function') {
            window.trackPromoterPixel('Purchase', purchaseParams);
        }

        this.headerBackButton.removeClass('shown');
        this.footerMessage.addClass('hidden');
        this.lockFormsExcept('finish');

        if(this.redirectFinishStep) {
            this.success = false;

            if(this.trackingCallback) {
                this.trackingCallback({ event: 'paid_maybe' });
            }
        }
        else {
            this.ticketsPreview = this.finishStep.find('.tickets');
            this.ticketsPreview.find('div.ticket-preview').find('div:first-child').find('div:first-child').text(this.eventTitle);

            window.setTimeout(function() {
                that.ticketsPreview.addClass('spread');
            }, 100);

            window.window.setTimeout(function() {
                that.ticketsPreview.addClass('fast-transitions');
            }, 200);

            if(profile.isLogged) {
                this.ticketsPreview.bind('click', function() {
                    if(profile.isLogged) {
                        window.open('/profile/tickets/', '_blank');
                    }
                });
            }
            else {
                this.finishStep.find('a.register').bind('click', function() {
                    if(that.embed) {
                        window.open('/', '_blank');
                    }
                    else {
                        that.closeModal();

                        window.setTimeout(function() {
                            profile.requestRegistration();
                        }, 200);
                    }

                    return false;
                });
            }

            this.success = true;

            if(this.trackingCallback) {
                this.trackingCallback({ event: 'paid_successfully' });
            }
        }

        this.unlock();
    }
}

export { BuyTicketsModal, BuyTicketsModalEmbedLayout, BuyTicketsModalEmbedLayoutProperties, BuyTicketsModalPaymentMethod }
